import { EquipmentMasterThemeModeConfig } from './types';

const light: EquipmentMasterThemeModeConfig = {
  equipmentMaster: {},
};

export default light;
